import { useState, useEffect, ChangeEvent } from 'react';
import { Link } from 'react-router-dom';
import { OrganismeFinancement } from '../../types/OrganismeFinancement';
import BackOfficeAPIClient from '../../clients/BackofficeAPIClient';

import lodash from 'lodash';

const apiClient = new BackOfficeAPIClient();

const List = () => {
  const [organismesFinancement, setOrganismesFinancement] = useState<OrganismeFinancement[]>([]);
  const [allOrganismesFinancement, setAllOrganismesFinancement] = useState<OrganismeFinancement[]>([]);
  const [filter, setFilter] = useState<string>('');
  const [fetching, setFetching] = useState<boolean>(false);

  useEffect(() => {
    fetchOrganismesFinancement();
  }, []);

  useEffect(() => {
    filterResults();
  }, [filter, allOrganismesFinancement]);

  const fetchOrganismesFinancement = async (): Promise<void> => {
    try {
      setFetching(true);
      let organismesFinancementData = await apiClient.get<OrganismeFinancement[]>('/organismesFinancement');
      organismesFinancementData = lodash.sortBy(organismesFinancementData, 'Descr');
      setAllOrganismesFinancement(organismesFinancementData);
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };

  const handleSetFilter = (event: ChangeEvent<HTMLInputElement>): void => {
    setFilter(event.target.value.toLowerCase());
  };

  const filterResults = (): void => {
    if (filter) {
      const filtered = lodash.filter(allOrganismesFinancement, (o: OrganismeFinancement) => {
        return (
          o.Descr.toLowerCase().includes(filter) ||
          (o.Adresse && o.Adresse.toLowerCase().includes(filter))
        );
      });
      setOrganismesFinancement(filtered as OrganismeFinancement[]);
    } else {
      setOrganismesFinancement(allOrganismesFinancement);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <h2 className="mb-4">Organismes de financement</h2>

          <div className="d-flex flex-row align-items-center justify-content-between mb-3">
            <Link to="/organismesFinancement/create" className="btn btn-light">
              <i className="fa fa-plus"></i> Ajouter
            </Link>

            <div className="d-flex flex-row align-items-center justify-content-end gap-2">
              <i className="fa fa-filter mr-1" />
              <input
                type="search"
                className="form-control form-control-sm float-right"
                value={filter}
                onChange={handleSetFilter}
                placeholder="Filtrer"
              />
            </div>
          </div>

          {fetching ? (
            <div className="d-flex flex-row align-items-center justify-content-center">
              <i className="fa fa-spinner fa-spin fa-fw"></i>
            </div>
          ) : (
            <table className="table table-striped table-hover table-sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>Adresse</th>
                  <th>Actif</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {organismesFinancement.map((o) => (
                  <tr key={o.IDMatOrgF}>
                    <td>{o.IDMatOrgF}</td>
                    <td>{o.Descr}</td>
                    <td>{o.Adresse || '-'}</td>
                    <td>
                      {o.Actif ? (
                        <span className="badge badge-success">Oui</span>
                      ) : (
                        <span className="badge badge-secondary">Non</span>
                      )}
                    </td>
                    <td className="text-right">
                      <Link to={'/organismesFinancement/' + o.IDMatOrgF} className="btn btn-primary btn-sm">
                        <i className="fa fa-pencil"></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default List;